export default "__VITE_ASSET__18fd3158__"